export const BIN_FILE_EXTENSION_ERROR =
  "Invalid file extension. Firmware files must end with .bin";

export function hasBinFileExtension(fileName: string): boolean {
  return /\.bin$/i.test(fileName.trim());
}

function formatFirmwareVersionLabel(rawVersion: string): string {
  const withV = rawVersion.startsWith("v") ? rawVersion : `v${rawVersion}`;
  const body = withV.slice(1);
  const suffixMatch = body.match(/^(\d+)(rc|newest)$/i);
  if (suffixMatch) {
    return `v${suffixMatch[1]}${suffixMatch[2]}`;
  }
  const digitsMatch = body.match(/^(\d{3,})$/);
  if (digitsMatch) {
    const digits = digitsMatch[1];
    const major = digits.slice(0, -2).replace(/^0+/, "") || "0";
    const minor = digits.slice(-2);
    return `v${major}.${minor}`;
  }
  return withV;
}

export function parseFirmwareVersionHint(fileName: string) {
  const withoutExt = fileName.replace(/\.bin$/i, "");
  const versionMatch =
    withoutExt.match(/_v(\d+(?:rc|newest)?)/i) ??
    withoutExt.match(/_v([^_/]+)$/i) ??
    withoutExt.match(/_([^_/]+)$/i);
  const rawVersion = versionMatch?.[1] ?? withoutExt;

  return { suggestedVersionName: formatFirmwareVersionLabel(rawVersion) };
}
